module.exports = __webpack_public_path__ + "static/PayAnalytics-7aeab3ae69ccf6ae95efad4da8f4170b.jpg";